<template>
  <h2>Account Credit - {{ accountCredit }}</h2>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { existingUser } from 'mixins/user'

  export default {
    mixins: [existingUser],

    created () {
      if (this.user.isClientOrCarrier) {
        this.getAccountCredit(this.user.id)
      }
    },

    watch: {
      user () {
        if (this.user.isClientOrCarrier) {
          this.getAccountCredit(this.user.id)
        }
      }
    },

    computed: {
      ...mapGetters('user/creditNote', ['accountCredit'])
    },

    methods: mapActions('user/creditNote', ['getAccountCredit'])
  }
</script>



// WEBPACK FOOTER //
// AccountCredit.vue?3a1f2232